export default {
  getAdminUserAll: '/admin/user/all',
  getAdminRole: '/admin/role/all',
  saveAdminUser: '/admin/user/save',
  exitAdminUserName: '/view/user/exist_username',
  editAdminUser: '/admin/user/update',
  updatePassword: '/admin/user/update_password',
}
